import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import '@fontsource/geist/400.css';
import '@fontsource/geist/600.css';
import '@fontsource/geist-mono/400.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/700.css';
import '@fontsource/noto-kufi-arabic/400.css';
import '@fontsource/noto-kufi-arabic/700.css';
import './globals.css';

import AuthProvider from '@/components/AuthProvider';
import IconProvider from '@/components/icons/IconProvider';
import { I18nProvider } from '@/i18n/I18nProvider';
import SWRProvider from '@/components/SWRProvider';
import { Toaster } from '@/components/ui/toaster';
import { NotificationToastListener } from '@/components/NotificationToastListener';
import { GlobalSpinnerProvider } from '@/components/GlobalSpinnerProvider';
import AegovDlsProvider from '@/components/AegovDlsProvider';
import HtmlLangDirProvider from '@/components/HtmlLangDirProvider';

import { AppRoutes } from './AppRoutes';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <I18nProvider defaultLocale="ar">
          <GlobalSpinnerProvider>
            <IconProvider>
              <SWRProvider>
                <NotificationToastListener />
                <AppRoutes />
                <AegovDlsProvider />
                <Toaster />
                <HtmlLangDirProvider />
              </SWRProvider>
            </IconProvider>
          </GlobalSpinnerProvider>
        </I18nProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
